const myMixin = {
  data() {
      return {
        isShowbtn: false,
      }
  },
  methods: {
    getDetail(goodsTypeId,id){
      this.$router.push({
        name: "Detail",
        query: {id:goodsTypeId,goodsId:id}
      });
    },
   showbtn(){
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop > 500){
        this.isShowbtn = true
      }else{
        this.isShowbtn = false
      }
   },
   backtop(){
    var timer = setInterval(function(){
      let osTop = document.documentElement.scrollTop || document.body.scrollTop;
      let ispeed = Math.floor(-osTop / 5); 
      document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
      this.isTop = true;
      if(osTop === 0){
        clearInterval(timer);
      }
    },30)
  }
  },
  mounted() {
    window.addEventListener("scroll",this.showbtn,true);
  }
}

export default myMixin;